import { c as _c } from "react/compiler-runtime";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import Image from "next/image";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
export default function UserPageHeaderPfp(t0) {
  const $ = _c(6);
  const {
    profile,
    defaultBanner1,
    defaultBanner2
  } = t0;
  if (profile.pfp) {
    let t1;
    if ($[0] !== profile.pfp) {
      t1 = getScaledImageUri(profile.pfp, ImageScale.W_200_H_200);
      $[0] = profile.pfp;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = <div className="tw-relative tw-z-10 tw-inline-flex tw-flex-shrink-0 tw-p-0.5 tw-rounded-xl tw-bg-white/10 tw-backdrop-blur-md tw-ring-1 tw-ring-white/20 tw-shadow-2xl"><Image unoptimized={true} src={t1} alt="Profile picture" width="144" height="144" className="tw-h-24 tw-w-auto tw-max-w-24 tw-rounded-xl tw-bg-iron-800 tw-object-contain sm:tw-h-36 sm:tw-max-w-36" /></div>;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  const t1 = `linear-gradient(45deg, ${defaultBanner1} 0%, ${defaultBanner2} 100%)`;
  let t2;
  if ($[4] !== t1) {
    t2 = <div className="tw-relative tw-z-10 tw-inline-flex tw-flex-shrink-0 tw-p-0.5 tw-rounded-xl tw-bg-white/10 tw-backdrop-blur-md tw-ring-1 tw-ring-white/20 tw-shadow-2xl"><div className="tw-h-24 tw-w-24 tw-rounded-xl sm:tw-h-36 sm:tw-w-36" style={{
        background: t1
      }} /></div>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}